<div class="page-container">
  <div class="titles-holder">
    <div class="merck-font-title">Home</div>
    <div class="sub-title">Please select between the dashboards!</div>
  </div>
  <div class="options-holder">
    <div class="option-container">
      <div class="option-holder">
        <div class="option-left-holder">
          <div class="option-title-holder">
            <div class="option-title">Market Expansion</div>
          </div>
          <div class="option-button" (click)="openMarketExpansion()">Go</div>
        </div>
        <div class="option-right-holder">
          <img src="assets/images/market_expansion_icon.png" alt="" />
        </div>
      </div>
    </div>
    <div class="option-container">
      <div class="option-holder">
        <div class="option-left-holder">
          <div class="option-title-holder">
            <div class="option-title">Specs Footprint</div>
          </div>
          <div class="option-button" (click)="openMecsFootPrint()">Go</div>
        </div>
        <div class="option-right-holder">
          <img src="assets/images/mecs-footprint-icon.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</div>
